/**
 * FE types for the OP-6491 filter-metadata catalog. Two sources: BFF `GET /portal/{contacts|organisations}/filter-metadata`
 * passes through the embedded OPQRY `GET /api/v1/query/{root}/metadata`; for `resident` (OP-8517) and `socialCaseFile`
 * (OP-8666) the catalog is OPSOL's curated `ResidentFilterCatalog` / `SocialCaseFileFilterCatalog`, served through
 * `GET /residents/filter-metadata` / `GET /social-case-files/filter-metadata`.
 *
 * Mirrors `OnePlatform.Opqry.Contracts.Filters.Requests.FilterMetadataResponse` — camelCase on the wire,
 * enums serialized as strings (BFF `JsonStringEnumConverter`).
 */
/** Remix icon class shown next to a field, keyed by its OPQRY `FieldType`. */
export const FILTER_FIELD_TYPE_ICON = {
    String: "ri-text",
    Number: "ri-hashtag",
    Decimal: "ri-hashtag",
    DateTime: "ri-calendar-line",
    Bool: "ri-toggle-line",
    Enum: "ri-list-check",
    Guid: "ri-fingerprint-line",
};
